module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "pull-right hidden-xs"
  }, [_c('b', [_vm._v("Version")]), _vm._v(" 2.1.0\n  ")]), _vm._v("\n  蓓盈纤 APP Admin © 2017 "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('strong', [_vm._v("蓓盈纤")])]), _vm._v(".\n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73a5d97c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Footer.vue
// module id = 460
// module chunks = 2